import React from "react";
import { CheckedIcon } from "@coolremote/shared";
import styles from "./ModbusSiteLibraryManagementDialog.module.css";

export interface IBannerState {
  type: "success" | "error";
  message: string;
  /** When set, renders a second colored row below the first inside the same banner. */
  secondaryType?: "success" | "error";
  secondaryMessage?: string;
}

const ErrorIcon: React.FC = () => (
  <svg width={16} height={16} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2 1 21h22L12 2Zm0 15.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM11 10h2v4h-2v-4Z" />
  </svg>
);

const BannerRow: React.FC<{ type: "success" | "error"; message: string }> = ({ type, message }) => (
  <div className={`${styles.bannerRow} ${type === "success" ? styles.bannerTextSuccess : styles.bannerTextError}`}>
    {type === "success" ? <CheckedIcon width={16} height={16} /> : <ErrorIcon />}
    <span>{message}</span>
  </div>
);

const LibraryActionBanner: React.FC<{ banner: IBannerState | null }> = ({ banner }) => {
  if (!banner) return null;
  if (!banner.secondaryMessage) {
    return (
      <div className={`${styles.banner} ${banner.type === "success" ? styles.bannerSuccess : styles.bannerError}`}>
        {banner.type === "success" ? <CheckedIcon width={16} height={16} /> : <ErrorIcon />}
        <span>{banner.message}</span>
      </div>
    );
  }
  return (
    <div className={`${styles.banner} ${styles.bannerMixed}`}>
      <BannerRow type={banner.type} message={banner.message} />
      <BannerRow type={banner.secondaryType ?? "error"} message={banner.secondaryMessage} />
    </div>
  );
};

export default LibraryActionBanner;
